import { createContext, useContext } from 'react';

export interface LicenseNoticeContextValue {
  /**
   * Pokazuje okno informujace, ze modul nie jest objety pakietem klienta.
   *
   * @param moduleLabel nazwa obszaru, ktory uzytkownik kliknal — trafia
   *                    do naglowka okna, zeby komunikat nie byl anonimowy
   */
  showLicenseNotice: (moduleLabel: string) => void;
}

export const LicenseNoticeContext = createContext<LicenseNoticeContextValue | null>(null);

/**
 * Dostep do okna informujacego o braku licencji na wybrany modul.
 * Rzuca poza `LicenseNoticeProvider`.
 */
export function useLicenseNotice(): LicenseNoticeContextValue {
  const context = useContext(LicenseNoticeContext);
  if (!context) {
    throw new Error('useLicenseNotice musi być użyte wewnątrz LicenseNoticeProvider.');
  }
  return context;
}
